import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import { Button, Container, Grid, Typography } from '@material-ui/core'
import bearIcon from '../../images/Bear-tutorial.svg'
import TutorialDroppable from '../../components/TutorialDroppable'

const TutorialScreen = ({ classes, setCurrentScreen }) => {

  const handleClick = () => setCurrentScreen('Quiz')

  return (
    <Grid className={classes.tutorialScreenContainer}>
      <Grid>
        <Typography className={classes.tutorialTitle}>
          TUTORIAL
        </Typography>
      </Grid>
      <Container maxWidth='md'>
        <Grid container justify='center' style={{ marginTop: '-30px'}}>
          <img src={bearIcon} className={classes.bearIcon} />
        </Grid>
        <Grid container justify='space-evenly' style={{ margin: '70px 0 25px 0'}}>
          <TutorialDroppable iconTitle='yes' />
          <TutorialDroppable iconTitle= 'no'/>
        </Grid>
        <Grid container justify='center'>
          <Button className={classes.gotItButton} onClick={handleClick}>
            Got it
          </Button>
        </Grid>
      </Container>
    </Grid>
  )
}

export default withStyles(styles)(TutorialScreen)
